import Api from 'services/AirBaltic/Api'
import conf from 'conf'

class Subscribe {
  subscribeWithApi (postObj) {
    return new Api().post('/profile/subscribe', postObj)
      .then(response => Promise.resolve(response.data))
      .catch(error => Promise.reject(error.response))
  }
}

export default Subscribe
